module.exports = __webpack_public_path__ + "files/11a476e07983e6ac743d9568f000e2c3.svg";